import React from "react";
import { FaSlidersH } from "react-icons/fa";
import ColourBar from "./ColourBar.tsx";

// Compact key for the travel-time colours. With onClick it acts as the
// button that opens the settings panel; without, it's display only (mobile,
// where the picker lives in the bottom sheet).
const Legend = ({
  maxMinutes,
  onClick,
}: {
  maxMinutes: number;
  onClick?: () => void;
}) => {
  const content = (
    <>
      <ColourBar />
      <div className="flex items-center justify-between gap-2 pt-0.5 text-[10px] text-gray-500">
        <span>0 min</span>
        <span className="flex items-center gap-1">
          {maxMinutes} min
          {onClick && <FaSlidersH className="text-gray-400" size={9} />}
        </span>
      </div>
    </>
  );

  const className =
    "rounded-lg border border-gray-200 bg-white/90 px-3 py-2 text-left shadow backdrop-blur";

  return onClick ? (
    <button
      onClick={onClick}
      title="Adjust the travel time range"
      className={`${className} hover:bg-white`}
    >
      {content}
    </button>
  ) : (
    <div className={className}>{content}</div>
  );
};

export default Legend;
